import * as React from 'react';
import LoginPopin from 'modules/login/login-popin/login-popin.component';
import LoginPopup from 'modules/login/login-popup';
import { ILoginProps } from 'modules/login/login.types';

export default class Login extends React.Component<ILoginProps, {}> {
    public render(): JSX.Element {
        const { hasTPCEnabled } = this.props;
        return hasTPCEnabled ? <LoginPopin {...this.props}/> : <LoginPopup {...this.props}/>;
    }
}
